import { create } from 'zustand';

interface ThemeState {
  isDark: boolean;
  toggle: () => void;
  setDark: (value: boolean) => void;
}

/** Applies or removes the `dark` class on the root <html> element. */
function applyThemeClass(isDark: boolean): void {
  const root = document.documentElement;
  if (isDark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

/** Read initial theme: localStorage > prefers-color-scheme > light */
function getInitialTheme(): boolean {
  const stored = localStorage.getItem('cloudmaster_theme');
  if (stored !== null) {
    return stored === 'dark';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

const initialDark = getInitialTheme();
applyThemeClass(initialDark);

export const useThemeStore = create<ThemeState>((set) => ({
  isDark: initialDark,

  toggle: () =>
    set((state) => {
      const next = !state.isDark;
      localStorage.setItem('cloudmaster_theme', next ? 'dark' : 'light');
      applyThemeClass(next);
      return { isDark: next };
    }),

  setDark: (value: boolean) => {
    localStorage.setItem('cloudmaster_theme', value ? 'dark' : 'light');
    applyThemeClass(value);
    set({ isDark: value });
  },
}));
